import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';

export const dayjsSetup = (): void => {
  dayjs.extend(utc);
  dayjs.extend(relativeTime);
};

export const getGearDateFilterFormat = (date: Date) => {
  return dayjs(date).hour(12).format('YYYY-MM-DDTHH:mm:ss') + 'Z';
};

export const getGearDateTimeFilterFormat = (date: Date) => {
  return dayjs.utc(date).format('YYYY-MM-DDTHH:mm:ss') + 'Z';
};

export const getRelativeTime = (date: Date): string => {
  return dayjs(date).fromNow();
};
